import { render } from "./ProcessRegistrationLinesBar.vue?vue&type=template&id=b90d993a&scoped=true&ts=true"
import script from "./ProcessRegistrationLinesBar.vue?vue&type=script&lang=ts"
export * from "./ProcessRegistrationLinesBar.vue?vue&type=script&lang=ts"

import "./ProcessRegistrationLinesBar.vue?vue&type=style&index=0&id=b90d993a&lang=scss&scoped=true"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b90d993a"]])

export default __exports__